<template>
    <div class="page-wrapper">
        <AppHeader title="Products" />
        <div class="container-fluid" style="display: flex; flex-direction: column; align-items: center;">
            <div class="touch-search-header" style="max-width: 900px; padding: 12px 15px;">
                <div class="touch-search-area" style="justify-content: center;">
                    <div class="input-group touch-search-group" style="max-width: 900px;">
                        <span class="input-group-addon">
                            <i class="glyphicon glyphicon-barcode"></i>
                        </span>
                        <input
                            type="text"
                            ref="item_barcode"
                            v-on:keyup.enter="getProduct(item_barcode)"
                            v-model="item_barcode"
                            id="item_barcode"
                            name="item_barcode"
                            class="form-control input-lg"
                            placeholder="Scan or Enter Product Barcode"
                        >
                        <span class="input-group-btn">
                            <button
                                class="btn btn-success btn-lg"
                                @click="getProduct(item_barcode)"
                            >
                                Search
                            </button>
                        </span>
                    </div>
                </div>
                <div class="touch-search-actions"></div>
            </div>
            <div v-show="showError" class="text-center" style="margin-top: 10px; width: 100%; max-width: 900px;">
                <label class="h4" style="color: #ff6b6b;"> {{ this.mainErrorMsg }} </label>
            </div>

            <div class="card" style="padding: 30px; border-radius: 15px; width: 100%; max-width: 800px; color: var(--theme-text-main); margin: 0 auto 15px;">

                <div v-if="showEditItem && product" style="margin-top: 20px;">
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label title="item_name" style="font-size:1.2em;">Product Name</label>
                                <input disabled type="text" v-model="product.item_name" class="form-control input-lg" 
                                    style="font-size:1.2em; background: rgba(0,0,0,0.2); border: 1px solid rgba(255,255,255,0.1); color: var(--theme-text-main);">
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label title="standard_rate" style="font-size:1.2em">Product Price</label>
                                <input disabled type="text" v-model="product.standard_rate" class="form-control input-lg" 
                                    style="font-size:1.2em; background: rgba(0,0,0,0.2); border: 1px solid rgba(255,255,255,0.1); color: var(--theme-text-main);">
                            </div>
                        </div>
                    </div>

                    <vue-barcode class="vue_barcode_ref" style="display: none;" v-if="product"
                        :options="{ width: 3 }" :value="product.barcode ? product.barcode : item_barcode"></vue-barcode>

                    <div class="row" style="margin-top: 20px; align-items: center; display: flex;">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <label style="font-size:1.2em;">Quantity To Print</label>
                                <input type="number" v-model="qty" class="form-control input-lg" 
                                    style="font-size:1.2em; border-radius: 8px; background: rgba(255,255,255,0.1); border: 1px solid rgba(255,255,255,0.2); color: var(--theme-text-main);"
                                    placeholder="1" />
                            </div>
                        </div>
                        <div class="col-sm-6" style="display: flex; justify-content: space-between; align-items: center; padding-top: 25px;">
                            <div style="display: flex; align-items: center;">
                                <input type="checkbox" v-model="isShelf" id="shelfTag" style="width: 20px; height: 20px; margin-right: 10px; cursor: pointer;">
                                <label for="shelfTag" style="font-size:1.3em; margin:0; cursor: pointer;">Shelf Tag</label>
                            </div>
                            <div>
                                <button v-if="isShelf" class="btn btn-success btn-lg" style="font-size:1.5em; min-width: 120px;" @click="printProductTag">Print</button>
                                <button v-else class="btn btn-success btn-lg" style="font-size:1.5em; min-width: 120px;" @click="printProduct">Print</button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
  
<script>
import axios from "axios";
import commonServices from "@/shared/commonServices"
import AppHeader from "@/components/AppHeader";
import Datepicker from 'vuejs3-datepicker';
import 'vue-date-pick/dist/vueDatePick.css';
import VueBarcode from '@chenfengyuan/vue-barcode';
export default {
    mixins: [commonServices],
    async mounted() {
        if (localStorage.userId !== undefined && localStorage.appId !== undefined) {
        } else {
            this.$router.push({ name: 'login' });
        }
        this.language = 'ar';
        this.handleLanguage();
        await this.getHeaderFooter();
        //this.getLogo();
        this.logoImage = '<img src="' + this.logoUrl + '" width="70" height="50" alt="Logo">';
    },
    components: { AppHeader, Datepicker, VueBarcode },
    data: function () {
        return {
            isShelf: false,
            tagHeader: '',
            tagFooter: '',
            qty: 1,
            showEditItem: false,
            reports_ok: false,
            showError: false,
            logoImage: '',
            mainErrorMsg: '',
            logoUrl: '',
            jsonData: {},
            itemData: {},
            language: 'en',
            languageName: '',
            toggle: true,
            item_barcode: '',
            product: {}
        }
    },
    methods: {
        printProduct() {
            let barcodeCanvas = document.querySelector('.vue_barcode_ref');
            let barcodeImageSrc = barcodeCanvas.toDataURL();
            let dupStr = '';
            for (let index = 0; index < this.qty - 1; index++) {
                dupStr += `<div style="display:flex;justify-content:center;align-items:center">
        <div style="width:50%">
            <p style="font-size:0.50rem">
                ${this.product.item_name}
            </p>
            <p style="font-size:0.50rem"> ${this.formatNumber(this.product.standard_rate)}</p>
            <img style="width:100%" src="${barcodeImageSrc}"/>
        </div>
    </div>
    ${this.tagFooter}
    <div class="break"></div>`
            }
            dupStr += `<div style="display:flex;justify-content:center;align-items:center;">
        <div style="width:50%">
            <p style="font-size:0.50rem">
                ${this.product.item_name}
            </p>
            <p style="font-size:0.50rem"> ${this.formatNumber(this.product.standard_rate)}</p>
            <img style="width:100%" src="${barcodeImageSrc}"/>
        </div>
        
    </div>
    ${this.tagFooter}
    `
            let elem = `
    ${this.tagHeader}
    ${dupStr}
    
</body>
</html>`;
            var mywindow = window.open('', 'PRINT', 'toolbar=no,status=no,menubar=no,scrollbars=no,resizable=no,left=0, top=0, width=10, height=10, visible=none');
            mywindow.document.write(elem);
            this.qty = '';
            setTimeout(function () { mywindow.print(); mywindow.close(); }, 300);
        },
        printProductTag() {
            let barcodeStr = this.product ? this.product.barcode ? this.product.barcode : this.item_barcode: this.item_barcode;
            let dupStr = '';
            for (let index = 0; index < this.qty - 1; index++) {
                dupStr += `<div style="display:flex;justify-content:center;align-items:center">
                    <div style="width:80%">
                        <h4>${this.product.item_code}</h4>
            <h4>
                ${this.product.item_name}
            </h4>
            <div style="display:flex;align-items:end;margin-bottom: .4rem; !important">
                <span style="margin-right:.7rem;">UGX</span>
                <h1>${this.formatNumber(this.product.standard_rate)}</h1>
                </div>
            <p>${barcodeStr}</p>
        </div>
    </div>
    <div class="break"></div>`
            }


            dupStr += `<div style="display:flex;justify-content:center;align-items:center">
                    <div style="width:80%">
                        <h4>${this.product.item_code}</h4>
            <h4>
                ${this.product.item_name}
            </h4>
            <div style="display:flex;align-items:end;margin-bottom: .4rem; !important">
                <span style="margin-right:.7rem;">UGX</span>
                <h1>${this.formatNumber(this.product.standard_rate)}</h1>
                </div>
            <p>${barcodeStr}</p>
        </div>
    </div>
    `
            let elem = `
            <html>
    <head>
        <style>
        *{
            font-weight:1000;
            line-height:1.2rem;
        }
            h1,h2,h3,h4,p{
                margin: 0 !important;
                margin-bottom: 0.8rem !important;
            }

        </style>
        </head>
        <body>
    ${dupStr}
    
</body>
</html>`;
            var mywindow = window.open('', 'PRINT', 'toolbar=no,status=no,menubar=no,scrollbars=no,resizable=no,left=0, top=0, width=10, height=10, visible=none');
            mywindow.document.write(elem);
            this.qty = '';
            setTimeout(function () { mywindow.print(); mywindow.close(); }, 300);
        },
        getProduct: async function (barcode) {
            this.itemData = {};
            this.itemData.appId = localStorage.appId;
            this.itemData.barcode = barcode;
            let itemData_ = JSON.stringify(this.itemData);
            try {

                let dataURL = this.apiURL + 'Products/findProductLocal';

                let response = await axios.post(dataURL, itemData_);
                if (response.data.status === 'success' && response.data.results.products.length > 0) {
                    this.product = response.data.results.products[0];
                    this.showEditItem = true;
                } else {
                    this.itemData = {};
                    let dataURL = this.apiURL + 'Products/findProductLocal';
                    this.itemData.appId = localStorage.appId;
                    this.itemData.item_code = barcode;
                    itemData_ = JSON.stringify(this.itemData);
                    let response = await axios.post(dataURL, itemData_);
                    if (response.data.status === 'success' && response.data.results.products.length > 0) {
                        this.product = response.data.results.products[0];
                        this.showEditItem = true;
                    } else {
                        this.showAlert("Item not found please try again");
                    }
                }
            }
            catch (error) {
                console.log(error);
                this.showAlert("Item not found please try again");
            }
        },

        updateProduct: async function () {
            this.itemData.appId = localStorage.appId;
            this.itemData.barcode = this.item_barcode;
            this.itemData.item_name = this.product.item_name;
            this.itemData.standard_rate = this.product.standard_rate;
            try {
                let dataURL = this.apiURL + 'Products/updateProductLocal';
                let response = await axios.post(dataURL, this.itemData);
                if (response.data.status === 'success') {
                    this.showSuccess("Product Updated Successfully!");
                    this.product = {};
                    this.showEditItem = false;
                } else {
                    this.showAlert("Error Happened Please Check Entered Data!");
                }

            }
            catch (error) {
                console.log(error);
            }
        },

        getCurrentDateTime() {
            let dateTimeStr = '';
            const nowDate = new Date();
            let year = nowDate.getFullYear();
            let month = nowDate.getMonth() + 1;
            let day = nowDate.getDate();
            var today = new Date();
            var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
            dateTimeStr = year + '-' + month + '-' + day + ' ' + time;
            return dateTimeStr;
        },

        getHeaderFooter: async function () {
            try {
                let dataURL = this.apiURL + 'Orders/getTagHeader';
                let logoJson = { "branchId": "1", "langId": "15" };
                let response = await axios.post(dataURL, logoJson);
                if (response.data.status === 'success') {
                    this.tagHeader = response.data.results.header;
                    this.tagFooter = response.data.results.footer;
                }
            }
            catch (error) {
                console.log(error);
            }
        },
        goLogin() {
            this.$router.push({ name: 'login', query: { redirect: '/login' } });
        },

        fixNumber(num) {
            let mum2 = parseFloat(Math.round(num)).toFixed(2);
            return mum2;
        },
        getImgUrl() {
            let logoUrlStr;
            logoUrlStr = this.logoUrl;
            return logoUrlStr;
        },
        getLogo: async function () {
            try {
                let dataURL = this.apiURL + 'Orders/getInvoiceLogo';
                let logoJson = { "appId": localStorage.appId };
                let response = await axios.post(dataURL, logoJson);
                if (response.data.status === 'success') {
                    this.logoUrl = response.data.results.logourl;
                }
            }
            catch (error) {
                console.log(error);
            }
        },
    }
}
</script>
<style>
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: left;
    color: #2c3e50;
    margin-top: 20px;
}

.glyphicon.glyphicon-ok {
    font-size: 30px;
}

.button {
    font: bold 15px Arial;
    text-decoration: none;
    background-color: #EEEEEE;
    color: #333333;
    /* padding: 2px 6px 2px 6px;
    border-top: 1px solid #CCCCCC;
    border-right: 1px solid #333333;
    border-bottom: 1px solid #333333;
    border-left: 1px solid #CCCCCC; */
}

.grid-container-element {
    display: grid;
    grid-template-columns: 5fr 1.5fr 1.5fr 1.5fr 0.5fr;
    grid-gap: 10px;
    border: 1px solid whitesmoke;
    border-left: 0px;
    border-right: 0px;
    border-top: 0px;
    width: 100%;
}

.grid-child-element_ {
    margin: 10px;
    border: 1px solid red;
}

.grid-child-element {
    margin: 2px;
    border-left: 0px;
    border-right: 0px;
    border-top: 0px;
    padding: 0 px;

}
</style>
